import { useEffect, useState } from "react";
import DepartmentList from "../../components/AdminComponents/PagesComponents/Department/DepartmentList";
import AddDepartmentModal from "../../components/AdminComponents/PagesComponents/Department/AddDepartmentModal";
import { addDepartment, getAllDepartments, toggleDepartmentStatus, updateDepartment } from "../../services/AdminServices";
import ConfirmActionModal from "../../components/AdminComponents/Modals/ConfirmActionModal";
import MessageModal from "../../components/AdminComponents/Modals/MessageModal";

const AdminDepartmentPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);

  const [confirmModal, setConfirmModal] = useState({ open: false, department: null });

  const [messageModal, setMessageModal] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  const showSuccess = (msg) => {
    setMessageModal({
      open: true,
      type: "success",
      title: "Success",
      message: msg,
    });
  };

  const showError = (msg) => {
    setMessageModal({
      open: true,
      type: "error",
      title: "Error",
      message: msg,
    });
  };

  const handleToggleRequest = (dept) => {
    setConfirmModal({ open: true, department: dept });
  };


  const handleConfirmToggle = async () => {
    try {
      await toggleDepartmentStatus(confirmModal.department.id);;
      await loadDepartments();
      showSuccess(confirmModal.department.active ? "Department deactivated successfully" : "Department activated successfully");
    } catch (err) {
      showError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setConfirmModal({ open: false, department: null });
    }
  };

  const loadDepartments = async () => {
    try {
      setLoading(true);
      const res = await getAllDepartments();
      if (res.success) {
        setDepartments(res.data);
      }
    } catch (err) {
      console.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadDepartments();
  }, []);


  const handleSave = async (formData) => {
    try {
      let res;

      if (editData) {
        res = await updateDepartment(editData.id, formData);
      } else {
        res = await addDepartment(formData);
      }

      if (res.success) {
        await loadDepartments();
        setOpenModal(false);
        setEditData(null); // 🔑 IMPORTANT
        showSuccess(res.message);
      }
    } catch (err) {
      showError(err?.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="p-4 admin-card-box space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="admin-heading text-blue">Department Master</h2>
        <button className="btnAdd" onClick={() => { setEditData(null); setOpenModal(true); }}>
          + Add Department
        </button>
      </div>

      <DepartmentList data={departments} loading={loading} onEdit={(d) => { setEditData(d); setOpenModal(true); }} onToggle={handleToggleRequest} />

      <AddDepartmentModal
        open={openModal}
        editData={editData}
        onClose={() => setOpenModal(false)}
        onSave={handleSave}
      />

      <ConfirmActionModal
        open={confirmModal.open}
        title={
          confirmModal.department?.active
            ? "Deactivate Department"
            : "Activate Department"
        }
        message={
          confirmModal.department?.active
            ? "Do you really want to deactivate this department?"
            : "Do you want to activate this department again?"
        }
        confirmText={
          confirmModal.department?.active ? "DEACTIVATE" : "ACTIVATE"
        }
        onConfirm={handleConfirmToggle}
        onClose={() =>
          setConfirmModal({ open: false, department: null })
        }
      />

      <MessageModal
        open={messageModal.open}
        type={messageModal.type}
        title={messageModal.title}
        message={messageModal.message}
        onClose={() =>
          setMessageModal({ ...messageModal, open: false })
        }
      />
    </div>
  );
};

export default AdminDepartmentPage;
